// 86d37db3t — temperature_type is a Creatable master seeded with 2 rows.
// Mirrors the vehicle-type pattern (utils/Logistic/vehicleType.ts) so the
// Set Filter on the DT reports can lazy-fetch the current set.

export const TEMPERATURE_TYPE_CREATABLE_FIELD_NAME = "temperature_type";

/** Rows seeded by the migration — protected from delete/rename in the FE. */
export const SEEDED_TEMPERATURE_TYPES: readonly string[] = ["Chilled", "Frozen"];
